// Registre du référentiel de mots SecurePass, versionné par langue (id "securepass").
// Un référentiel publié est IMMUABLE : une évolution crée une v2 (la v1 reste servie telle quelle).
// Ajouter une langue = importer son module et l'enregistrer ici (voir docs/ADDING_LANGUAGE.md).
import * as frV1 from "./fr";
import * as enV1 from "./en";
import { getLocaleConfig } from "../i18n/locales";

const MODULES = [frV1, enV1];
const LABELS = { fr: "Français", en: "English" };

const REGISTRY = {};
MODULES.forEach(({ meta, words }) => {
  REGISTRY[meta.id] = REGISTRY[meta.id] || {};
  REGISTRY[meta.id][meta.locale] = REGISTRY[meta.id][meta.locale] || {};
  REGISTRY[meta.id][meta.locale][meta.version] = { meta, words };
});

export const AVAILABLE_WORDLISTS = MODULES.map(({ meta }) => ({ ...meta, label: LABELS[meta.locale] || meta.locale }));

// Lève une erreur claire si id/locale/version inconnu.
export function getWordlist({ id, locale, version }) {
  const entry = REGISTRY?.[id]?.[locale]?.[Number(version)];
  if (!entry) {
    throw new Error(`Dictionnaire introuvable: ${id}/${locale}/v${version}`);
  }
  return { words: entry.words, meta: entry.meta };
}

// Langue d'interface -> wordlistLocale du registre des langues -> securepass/<locale>/v1.
export function getWordlistForLanguage(lang, { id = "securepass", version = 1 } = {}) {
  return getWordlist({ id, locale: getLocaleConfig(lang).wordlistLocale, version });
}
